// Unpublished Work © 2026 Deere & Company.

import * as actions from '../../action-list';
import {ApplicationStatus} from '../../state/struct/digital-user-search/application-status';
import {DigitalUserSearch} from '../../state/struct/digital-user-search/digital-user-search';

const setDigitalUserSearchServiceError = (state, action) => ApplicationStatus.update(state, {
    digitalUserSearchError: {
        $merge: action.digitalUserSearchError
    }
});

const updateHasSearchStarted = (state, action) => ApplicationStatus.update(state, {
    hasSearchStarted: {
        $set: action.hasSearchStarted
    }
});

const updateIsViewResultsLoading = (state, action) => ApplicationStatus.update(state, {
    isViewResultsLoading: {
        $set: action.isViewResultsLoading
    }
});

const updateIsInitializing = (state, action) => ApplicationStatus.update(state, {
    isInitializing: {
        $set: action.isInitializing
    }
});

const markInitialized = (state) => ApplicationStatus.update(state, {
    hasInitialized: {
        $set: true
    }
});

const resetApplicationStatus = (state) => new ApplicationStatus({
    hasInitialized: state.hasInitialized
});

export const applicationStatus = (state = new DigitalUserSearch({}).applicationStatus, action = {}) => {
    const actionHandlers = {
        [actions.SET_DIGITAL_USER_SEARCH_ERROR]: setDigitalUserSearchServiceError,
        [actions.SET_DIGITAL_USER_SEARCH_STARTED]: updateHasSearchStarted,
        [actions.SET_DIGITAL_USER_SEARCH_LOADING]: updateIsViewResultsLoading,
        [actions.SET_DIGITAL_USER_SEARCH_INITIALIZING]: updateIsInitializing,
        [actions.SET_DIGITAL_USER_SEARCH_INITIALIZED]: markInitialized,
        [actions.RESET_DIGITAL_USER_SEARCH]: resetApplicationStatus
    };
    const reducer = actionHandlers[action.type];

    return reducer ? reducer(state, action) : state;
};
